import { render } from "./ScopeTab.vue?vue&type=template&id=531ebe9e&scoped=true"
import script from "./ScopeTab.vue?vue&type=script&lang=js"
export * from "./ScopeTab.vue?vue&type=script&lang=js"

import "./ScopeTab.vue?vue&type=style&index=0&id=531ebe9e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531ebe9e"]])

export default __exports__